import React from 'react';
import App from './App';
import './Rubix.css';

const Rubix = () => (
  <App />
)

export default Rubix;



/** WEBPACK FOOTER **
 ** ./src/rubix/Rubix.js
 **/